const hostURL = "https://crpmenu.gri.msstate.edu/";

// const hostURL = 'http://localhost:8080/';

export default hostURL;
